import React, { Component } from 'react';
import Lottie from 'react-lottie';

import styles from "components/ClientContentStyles.module.scss";
import logo from "images/cos-logo.png";
import "animate.css";
import ErrorModal from './Utility/ErrorModal';

const animations = [
    "bounce",
    "rubberBand",
    "shakeX",
    "shakeY",
    "headShake",
    "swing",
    "tada",
    "wobble",
    "jello",
    "heartBeat",
];

const GameStates = {
    Loading: "loading",
    Tutorial: "tutorial",
    Question: "question",
    Answers: "answers",
    Results: "results",
    EndGame: "end_game",
};

export default class ClientContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            room: props.room,
            player: props.player,
            gameState: null,
            tickedSkipTutorial: false,
            showStartWarning: false,
        };
    }

    componentDidMount() {
        //this.props.room.state.cosData.onChange(() => {
            
        //});
        //this.props.room.state.cosData.listen("gameState", (value) => {
        //    if (value != GameStates.Loading && value != GameStates.EndGame && this.state.showStartWarning) {
        //        this.setState({ showStartWarning: false });
        //    }

        //    this.setState({ gameState: value });
        //});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.gameState !== GameStates.Loading && nextProps.gameState != GameStates.EndGame && this.state.showStartWarning) {
            this.setState({ showStartWarning: false });
        }

        this.setState({ player: nextProps.player, });
    }

    animateCSS = (element, animation, prefix = 'animate__') =>
        // We create a Promise and return it
        new Promise((resolve, reject) => {
            const animationName = `${prefix}${animation}`;
            let node;
            if (typeof element === `string`) {
                node = document.querySelector(element);
            } else {
                node = element;
            }
            node.classList.add(`${prefix}animated`, animationName);

            // When the animation ends, we clean the classes and resolve the Promise
            function handleAnimationEnd(event) {
                event.stopPropagation();
                node.classList.remove(`${prefix}animated`, animationName);
                resolve('Animation ended');
            }

            node.addEventListener('animationend', handleAnimationEnd, { once: true });
        });

    doAnimation = () => {
        let animation = this.getRandomElement(animations);
        this.state.room.send("animate_potato", { animation: animation, });
        if (document.getElementById(`potato`)) {
            this.animateCSS(`#potato`, animation);
        }
    }

    getRandomElement(array) {
        return array[Math.random() * array.length >> 0];
    }

    clickStartGame = (confirm = false) => {
        let allConnected = true;
        for (let i = 0; i < this.props.players.length; i++) {
            let value = this.props.players[i].connected;
            if (value === false) allConnected = false;
        }

        if (!confirm && !allConnected) {
            this.setState({ showStartWarning: true });
        } else {
            this.setState({ showStartWarning: false })
            this.state.room.send("begin_game", { skipTutorial: this.state.tickedSkipTutorial, });
        }
    }

    clickGoToLobby = () => {
        this.state.room.send("change_game", {});
    }


    clickPlayAgain = (confirm = false) => {
        let allConnected = true;
        for (let i = 0; i < this.props.players.length; i++) {
            let value = this.props.players[i].connected;
            if (value === false) allConnected = false;
        }

        if (!confirm && !allConnected) {
            this.setState({ showStartWarning: true });
        } else {
            this.setState({ showStartWarning: false })
            this.state.room.send("new_game", {});
        }
    }

    toggleSkipTutorial = (e) => {
        console.log("cb value: " + e.target.checked);
        this.setState({ tickedSkipTutorial: e.target.checked });
    }

    closeStartWarning = () => {
        this.setState({ showStartWarning: false });
    }

    confirmStartGame = () => {
        this.clickStartGame(true);
    }

    confirmPlayAgain = () => {
        this.clickPlayAgain(true);
    }

    render() {
        return (
            <div className={styles.defaultSection}>
                {/*<img src={logo} className={styles.logo} />*/}
                {
                    this.props.title.length > 0 && this.props.content.length > 0 &&
                    <div className={styles.contentSection}>
                        <div className={styles.title}>{this.props.title}</div>
                        <div className={styles.content}>{this.props.content}</div>
                    </div>
                }
                <div className={styles.playerSection}>
                    {
                        this.state.player ?
                            <React.Fragment>
                                <div id="potato" onClick={this.doAnimation} className={styles.potato}>
                                    <img style={{ width: "100%", height: "100%", padding: "5%", objectFit: "contain"  }} src={this.state.player.avatar} alt="avatar" />
                                </div>
                                <div className={styles.text}>{this.state.player.name}</div>
                                {/*<div className={`${styles.text} ${styles.score}`}>Score: {this.state.player.cosData.score}</div>*/}
                            </React.Fragment>
                            :
                            null
                    }
                </div>
                {
                    this.state.player && this.state.player.primaryPlayer && [GameStates.Loading, GameStates.EndGame].includes(this.props.gameState) && this.props.hostConnected &&
                    <React.Fragment>
                        {
                            this.props.gameState == GameStates.Loading &&
                            <div className={styles.buttons}>
                                <div className={styles.button} onClick={() => this.clickStartGame()}>Start Game</div>
                                <div className={styles.button} onClick={this.clickGoToLobby}>Go To Lobby</div>
                                <div className={styles.skipBox}>
                                    <input className={styles.checkbox} type="checkbox" id="checkbox" name="checkbox" onChange={this.toggleSkipTutorial} />
                                    <label for="checkbox">Skip Tutorial</label>
                                </div>
                            </div>
                        }
                        {
                            this.props.gameState == GameStates.EndGame &&
                            <div className={styles.buttons}>
                                <div className={styles.button} onClick={() => this.clickPlayAgain()}>Play Again</div>
                                <div className={styles.button} onClick={this.clickGoToLobby}>Different Game</div>
                            </div>
                        }
                    </React.Fragment>
                }
                {
                    this.state.showStartWarning && [GameStates.Loading, GameStates.EndGame].includes(this.props.gameState) && this.props.hostConnected &&
                    <ErrorModal
                        title={"Are you ready to play?"}
                        styles={"d-flex"}
                        message={"It looks like all the players might not be connected to the game, are you sure you would like to start?"}
                        callback={this.closeStartWarning}
                        callbackText={"No"}
                        callback2={this.props.gameState === GameStates.Loading ? this.confirmStartGame : this.confirmPlayAgain}
                        callbackText2={"Yes"}
                    />
                }
            </div>
        )
    }

}